<template>
  <div>
    <div class="banner_wa">
      <div class="d-flex align-center justify-center pa-1">
        <div class="content_wa">
          <div class="d-flex justify-center">
            <img
              src="../../assets/img/penjurusan/aset jurusan wa 1.png"
              height="100px"
              alt=""
            />
          </div>
          <p class="ma-0 text-center download_txt">
            <b> {{ redaksi }}</b>
          </p>
          <p class="large_txt text-center">
            Konsultasi melalui WhatsApp secara GRATIS!
          </p>
          <div class="d-flex justify-center">
            <a
              href="https://wa.wizard.id/63b84f"
              class="anchol"
              target="_blank"
            >
              <v-btn
                x-large
                class="rounded-md"
                depressed
                color="#53C764"
                dark
                elevation="2"
                ><v-icon class="mr-2">mdi-whatsapp</v-icon>Konsultasi
                Gratis</v-btn
              >
            </a>
          </div>
        </div>
      </div>
      <img
        class="img_wa_left"
        src="../../assets/img/penjurusan/aset jurusan wa 6.png"
        alt="img_wa_left"
      />
      <img
        class="img_wa_right"
        src="../../assets/img/penjurusan/aset jurusan wa 5.png"
        alt="img_wa_right"
      />
    </div>
    <div class="banner_download">
      <div class="half d-flex align-center justify-center pa-1">
        <div class="content_download">
          <p class="white--text ma-0 download_txt">
            Lebih Asik di Smartphone, <br />
            Unduh Aplikasi <b>Teman</b> Bakat Sekarang!
          </p>
          <div class="temp_btn">
            <a
              href="https://play.google.com/store/apps/details?id=com.temanbakat"
              class="anchol"
              target="_blank"
            >
              <v-btn
                dark
                color="#000"
                depressed
                class="mr-2 mt-2 py-6 text-capitalize"
              >
                <div class="d-flex">
                  <v-icon large class="mr-2">mdi-google-play</v-icon>
                  <div>
                    <p class="ma-0 small_txt text-left">Get it on</p>
                    <b class="text-left">Google Play</b>
                  </div>
                </div>
              </v-btn>
            </a>
            <a
              href="https://apps.apple.com/us/app/teman-bakat/id1588358323"
              class="anchol"
              target="_blank"
            >
              <v-btn
                depressed
                color="#000"
                dark
                class="py-6 text-capitalize mt-2"
              >
                <div class="d-flex">
                  <v-icon large class="mr-2">mdi-apple</v-icon>
                  <div>
                    <p class="ma-0 small_txt text-left">Get it on</p>
                    <b class="text-left">App Store</b>
                  </div>
                </div>
              </v-btn>
            </a>
          </div>
        </div>
      </div>
      <img
        class="img_dwnld"
        src="../../assets/img/penjurusan/banner_download (2).png"
        alt=""
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "bannerBtm",
  props: ["redaksi"],
};
</script>

<style scoped>
.banner_download {
  height: 100vh;
  position: relative;
  background: #3b053c;
  display: flex;
  box-sizing: border-box;
  overflow: hidden;
}
.banner_wa {
  height: 100vh;
  position: relative;
  background: url("../../assets/img/penjurusan/asset1a.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  overflow: hidden;
}

.half {
  width: 50%;
}
.content_download {
  position: relative;
  width: 80%;
  z-index: 2;
}
.content_wa {
  padding-top: 50px;
  position: relative;
  width: 50%;
  z-index: 2;
}
.download_txt {
  font-size: 30px;
}
.temp_btn {
  display: flex;
}
.anchol {
  text-decoration: none;
}
.small_txt {
  font-size: small;
}
.large_txt {
  font-size: large;
}
.img_dwnld {
  position: absolute;
  right: 0;
  bottom: 0;
  height: 500px;
}
.img_wa_left {
  position: absolute;
  left: -30px;
  bottom: 0;
  height: 400px;
}
.img_wa_right {
  position: absolute;
  right: -30px;
  bottom: 0;
  height: 400px;
}
@media (max-width: 768px) {
  .half {
    width: 100%;
  }
  .content_download {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.112);
    padding: 20px;
  }
  .content_wa {
    padding-top: 50px;
    position: relative;
    width: 100%;
    z-index: 2;
  }
  .download_txt {
    font-size: 25px;
  }
  .img_dwnld {
    height: 400px;
  }
  .img_wa_left {
    height: 300px;
  }
  .img_wa_right {
    height: 300px;
  }
}
@media (max-width: 576px) {
  .temp_btn {
    display: flex;
    flex-direction: column;
  }
  .img_wa_left {
    height: 200px;
  }
  .img_wa_right {
    height: 200px;
  }
}
@media (max-width: 396px) {
}
</style>
